import { createAction, props } from '@ngrx/store';

export const openSaving = createAction('[ COMPONENT ] Open Saving',
  props<{ isShow, isError, message }>()
);
export const closeSaving = createAction('[ COMPONENT ] Close Saving');
export const openLoader = createAction('[ COMPONENT ] Open Loader');
export const closeLoader = createAction('[ COMPONENT ] Close Loader');
